var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLabs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "labs_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 148 148",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".labs_svg__st0{fill:none;stroke:var(--color-text);stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "labs_svg__st0",
    d: "M55.4 137.1h64.9c8.7 0 14.5-9.1 10.7-16.9l-29.6-62.9c-1.6-3.5-2.5-7.3-2.5-11.1V21.7c2.3 0 4.2-1.9 4.2-4.2v-2.4c0-2.3-1.9-4.2-4.2-4.2H71.7c-2.3 0-4.2 1.9-4.2 4.2v2.3c0 2.3 1.9 4.2 4.2 4.2v24.5c0 3.9-.9 7.7-2.5 11.1L55.3 86.7M98.9 21.7h-9.8M98.9 36.3h-9.8M98.9 51h-9.8M98.9 43.7h-6.7M20.1 73h9.8M20.1 65.7h6.7M20.1 58.3h9.8M20.1 43.7h9.8M15.8 33v6.6c0 2.3 1.8 4.1 4.1 4.1v81.4c0 6.6 5.4 12 12 12h3.4c6.6 0 12-5.4 12-12V43.7c2.3 0 4.1-1.8 4.1-4.1V33H15.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M125.6 122.7l-14.8-31.4c-8.6 9.8-29.7 20.1-55.4 22.7v16.9h64.9c2.9 0 4.4-1.9 4.9-2.7.5-.7 1.6-2.9.4-5.5z",
    fill: "var(--color-icon-secondary)"
  })));
}
export default SvgLabs;